<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-04 16:31:06
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-16 13:03:34
 * @name: 填写售后服务单
 * @Description: 填写售后服务单
 * @FilePath: \project\src\views\index\afterSale\waitDealSignServiceForm\waitDealSignServiceForm.vue
 * @Author: desktop
-->
<template>
  <div class="waitDealSignServiceForm">
    <div class="container">
      <div class="head">
        <el-button size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="content">
        <div class="card">
          <div class="title">
            <font>基本信息</font>
          </div>
          <div class="info">
            <div class="row">
              <div class="col">
                <font class="label required">经销商：</font>
                <font class="value">
                  <el-input
                    v-model="form.agency_name"
                    placeholder="请输入经销商..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
              <div class="col">
                <font class="label required">联系方式：</font>
                <font class="value">
                  <el-input
                    v-model="form.mobile"
                    placeholder="请输入联系方式..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <font class="label required">地址：</font>
                <font class="value">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入地址..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
              <div class="col">
                <font class="label required">服务日期：</font>
                <font class="value">
                  <el-date-picker
                    size="mini"
                    style="width: 100%"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    v-model="form.service_date_time"
                    type="date"
                    placeholder="请选择服务日期..."
                  >
                  </el-date-picker>
                </font>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <font class="label textarea-label">备注：</font>
                <font class="value">
                  <el-input
                    type="textarea"
                    v-model="form.basic_remark"
                    placeholder="请输入备注..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="title">
            <font>售后信息</font>
          </div>
          <div class="info">
            <div class="row">
              <div class="col">
                <font class="label required">钢琴品牌：</font>
                <font class="value">
                  <el-input
                    v-model="form.piano_brand"
                    placeholder="请输入钢琴品牌..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
              <div class="col">
                <font class="label required">钢琴型号：</font>
                <font class="value">
                  <el-input
                    v-model="form.piano_type"
                    placeholder="请输入钢琴型号..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <font class="label required">琴号：</font>
                <font class="value">
                  <el-input
                    v-model="form.piano_number"
                    placeholder="请输入琴号..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
              <div class="col">
                <font class="label required">状况描述：</font>
                <font class="value">
                  <el-input
                    v-model="form.situation_des"
                    placeholder="请输入状况描述..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <font class="label required">服务项目：</font>
                <font class="value">
                  <el-input
                    v-model="form.item_service"
                    placeholder="请输入服务项目..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
              <div class="col">
                <font class="label required">调律师：</font>
                <font class="value">
                  <el-input
                    v-model="form.tuner"
                    placeholder="请输入调律师..."
                    size="mini"
                  ></el-input>
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-group">
          <div class="card">
            <el-button
              size="mini"
              type="primary"
              @click="btnClickHandler({}, $route.query)"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import { getEventBus } from "@/config/eventBus.config.js";
import { debounceation } from "@/utils/decorator";
export default {
  data() {
    return {
      issueService: new issueService(),
      form: {
        agency_name: "",
        mobile: "",
        address: "",
        service_date_time: "",
        basic_remark: "",
        piano_brand: "",
        piano_type: "",
        piano_number: "",
        situation_des: "",
        item_service: "",
        tuner: "",
      },
    };
  },
  created() {
    this.setDefault();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 填入默认信息
     */
    setDefault() {
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          this.form.agency_name = res.data.agency.agency_name;
          this.form.mobile = res.data.agency.mobile;
          this.form.address = res.data.agency.address;
          this.form.piano_type = res.data.piano_model;
          this.form.piano_number = res.data.piano_no;
          this.form.situation_des = res.data.question;
          this.form.tuner = res.data.content.express_user;
        });
    },
    @debounceation(300)
    back() {
      this.$router.go(-1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 按钮点击触发
     * @param {Object} item 点击的按钮数据
     * @param {Object} query 页面参数
     */
    @debounceation(300)
    btnClickHandler(item, query) {
      let req = {
        run_process_id: query.run_process_id,
        issue_id: query.issue_id,
        ...this.form,
      };
      this.issueService.addServiceIssue(req).then((res) => {
        this.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
        this.$EventBus.$emit(getEventBus("待处理列表发生变更"));
        this.$router.go(-2);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.waitDealSignServiceForm {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    .head {
      margin-bottom: 10px;
      @extend .et-flex-start;
    }
    .content {
      width: 100%;
      @extend .et-flex-column-normal;
      .card {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0 !important;
        }
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-radius: $Vars-border-radius-normal;
        box-shadow: $Vars-boxShadow-normal;
        .title {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniTitle-size;
          font-weight: bold;
          border-bottom: 1px solid $Vars-border-second-color;
        }
        .info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-column-normal;
          .row {
            width: 100%;
            padding: 5px 0;
            @extend .et-flex-start;
            .col {
              width: 50%;
              @extend .et-flex-start;
              .label {
                width: 80px;
                margin-right: 10px;
                &.textarea-label {
                  align-self: flex-start;
                }
                &.required::before {
                  content: "*";
                  width: 10px;
                  margin-right: 5px;
                  color: red;
                }
              }
              .value {
                flex: 1;
                margin-right: 10px;
              }
            }
          }
        }
      }
      .btn-group {
        margin: 10px 0;
        width: 100%;
        .card {
          width: 100%;
          box-sizing: border-box;
          padding: 10px;
          border-radius: $Vars-border-radius-normal;
          box-shadow: $Vars-boxShadow-normal;
          @extend .et-flex-center;
        }
      }
    }
  }
}
</style>